<template>
  <div class="content conta">
    <h1><span><i class="fas fa-book"></i> Cortesia</span></h1>

    <b-tabs pills nav-class="mb-5 mt-5" lazy>
      <b-tab title="Cortesias" @click="changeRouter('cortesias')" :active="isActive('cortesias')">
        <lista-cortesias />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ListaCortesias from '@/modules/Cortesia/components/ListaCortesias'

export default {
  name: 'CortesiaView',
  components: { ListaCortesias },
  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/cortesia/${tab}`)
    }
  }
}
</script>
